import './style.scss'
import CustomButton from 'general/components/Button/CustomButton'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd'
import { useState } from 'react'
ModalNotificationPopUp.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  describeText: PropTypes.string,
}

ModalNotificationPopUp.defaultProps = {
  title: 'Cảnh báo',
  describeText: '',
  icon: 'fa-light fa-triangle-exclamation',
  show: false,
  onClose: null,
}

function ModalNotificationPopUp(props) {
  const { title, describeText, icon, ...restProps } = props
  const [checkBox, setCheckBox] = useState(false)
  return (
    <Modal
      className="ModalNotificationPopUp font-sfpro-regular"
      {...restProps}
      //   size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      dialogClassName="modal-bottom-right"
    >
      <Modal.Header className=" ">
        <div className="d-flex justify-content-between align-items-center w-120">
          <span className="font-weight-bolder" style={{ fontSize: '18px' }}>
            <i
              className={`${icon} mr-3`}
              style={{ fontSize: 18, color: '#ff9f0e' }}
            ></i>
            Cập nhật tự động Số hóa đơn và Ký hiệu hóa đơn
          </span>
          {/* Nút X */}
          <span className="close-icon" onClick={props.onClose}>
            ✕
          </span>
        </div>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="d-flex justify-content-start p-5">
          <div display="flex" className="w-full">
            <p style={{ fontSize: '13px', fontWeight: '400' }}>
              <b>Kính gửi: </b> Quý khách hàng
            </p>
            <p style={{ fontSize: '13px', fontWeight: '400' }}>
              Từ ngày <b>01/01/2026</b> Số hóa đơn và Ký hiệu hóa đơn điện tử sẽ
              được cập nhật tự động theo quy định tại <b>Khoản 3</b>,
              <b> Điều 10 Nghị định 123</b> và{' '}
              <b>Điểm b Khoản 1 Điều 5 của Thông tư 32/2025</b>, cụ thể như sau:
            </p>
            <ul style={{ fontSize: '13px', fontWeight: '400' }}>
              <li>
                <b>Số hóa đơn</b> bắt đầu từ số <b>1</b>.
              </li>
              <li>
                <b>Ký hiệu hóa đơn</b> cập nhật năm lập hóa đơn từ <b>25</b>{' '}
                thành <b>26</b> theo năm Dương lịch.
              </li>
            </ul>
            <p style={{ fontSize: '13px', fontWeight: '400' }}>
              <b>Ví dụ: </b>Đơn vị đang sử dụng ký hiệu hóa đơn là C<b>25</b>
              TYY, sang năm 2026 sẽ chuyển thành C<b>26</b>TYY, số hóa đơn bắt
              đầu lại từ số 1. Khi tạo lập hóa đơn từ ngày <b>1/1/2026</b>, đơn
              vị lựa chọn ký hiệu đúng với năm tương ứng để sử dụng
            </p>
            <p style={{ fontSize: '13px', fontWeight: '400' }}>Trân trọng.</p>
            <p style={{ fontSize: '13px', fontWeight: '400' }}>
              Việc cập nhật này không ảnh hưởng đến quá trình sử dụng hóa đơn
              điện tử của đơn vị.
            </p>
            <p style={{ fontSize: '13px', fontWeight: '400' }}>
              <b>Lưu ý: </b>Nếu đơn vị có sử dụng phần mềm kế toán, phần mềm bán
              hàng, vui lòng liên hệ đơn vị cung cấp để được hỗ trợ cập nhật số
              và ký hiệu hóa đơn đúng quy định.
            </p>
            <p tyle={{ fontSize: '13px', fontWeight: '400' }}>
              Chúng tôi thông báo để Quý khách hàng được biết.
            </p>
            <p style={{ fontSize: '13px', fontWeight: '400' }}>
              Xin trân trọng cảm ơn!
            </p>
            <p style={{ fontSize: '13px', fontWeight: '400' }}>
              <Checkbox
                checked={checkBox}
                onChange={(e) => {
                  const checked = e.target.checked
                  setCheckBox(checked)
                  if (checked) {
                    localStorage.setItem('hideNotificationPopup', 'true')
                  } else {
                    localStorage.removeItem('hideNotificationPopup')
                  }
                }}
              >
                <span
                  style={{
                    fontWeight: '400',
                    color: '#474e7e',
                    fontSize: '13px',
                  }}
                >
                  Không hiển thị lại
                </span>
              </Checkbox>
            </p>
          </div>
        </div>
      </Modal.Body>

      {/* <Modal.Footer className="">
        <CustomButton
          backgroundColor="#304FFD"
          text="Đóng"
          width="90px"
          color="white"
          onClick={props.onClose}
        ></CustomButton>
      </Modal.Footer> */}
    </Modal>
  )
}

export default ModalNotificationPopUp
